import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery, clientGraphQLAuthMutation } from "../../../../core/data/GraphQLApi";
import { clientPOST } from "../../../../core/data/RestApi";
import { endpoints } from "../../../../core/defaultValues";
import { resetALL } from "../../../../.globals/redux/actions";
import { ExceptionManager } from "../../../../core/logManager";
import { isJson } from "../../../../core/data/Helpers";
//actions
import { logout } from "Redux/actions";
import { setCookie, eraseCookie } from "Core/views/login/helper";

const INIT_STATE = {
  loading: false,
  loadingSM: false,
  cognitoValues: null,
  sessionId: null,
  verifiedUsers: null,
  error: null,
  showConfirm: false,
  token: null,
  showMultiaccount: false,
  loadingLoginPage: false,
  loginPage: null,
  session: null,
  username: null,
  termAndConditionData: {},
  checkUser: null,
  isSocialMediaLogin: false
};

const route = "core/views/login/redux/slice";

export const checkLoginUserByCode = createAsyncThunk("core/views/login/checkLoginUserByCode",
  async (payload, { dispatch, rejectWithValue }) => {
    const domainUri =
      window.location.hostname === "localhost"
        ? `http://localhost:40000`
        : `https://${window.location.hostname}`;
    const { code, navigate } = payload;
    try {
      let headers = {
        "Content-Type": "application/x-www-form-urlencoded"
      };

      const data = await clientPOST(
        "",
        {
          code,
          client_id: `${endpoints.COGNITO_CLIENT_ID}`,
          grant_type: "authorization_code",
          redirect_uri: `${domainUri}/login-social-media`
        },
        `${endpoints.COGNITO_DOMAIN_USER_POOL_EXTERNAL}oauth2/token`,
        headers,
        true
      );

      if (data) {
        localStorage.setItem("AccessToken", data.access_token);
        localStorage.setItem("RefreshToken", data.refresh_token);
        localStorage.setItem("IdToken", data.id_token);
        setCookie("GPSTSharedOAUTHToken", data.id_token, 1);
        //remove local preferences
        localStorage.removeItem("preferencesUser");
        localStorage.removeItem("preferencesCompany");
        localStorage.removeItem("preferencesOther");
        const dataToLoginPHP = await clientQuery(
          `{
            User: getLoginInformation{
            username
            }
        }`,
          {},
          endpoints.GRAPHQL_GENERAL
        );
        if (dataToLoginPHP?.User) {
          const username = dataToLoginPHP?.User?.username;
          localStorage.setItem("username", username);
          dispatch(loginResult({ cognitoValues: data, showConfirm: false }));
          navigate("/");
        }
      }
    } catch (exc) {
      // catch throw
      localStorage.removeItem("AccessToken");
      localStorage.removeItem("RefreshToken");
      localStorage.removeItem("IdToken");
      localStorage.removeItem("username");
      eraseCookie("GPSTSharedOAUTHToken");
      const domainUri =
        window.location.hostname === "localhost"
          ? `http://localhost:40000`
          : `https://${window.location.hostname}`;
      window.location = `${endpoints.COGNITO_DOMAIN_USER_POOL_EXTERNAL}logout?client_id=${endpoints.COGNITO_CLIENT_ID}&logout_uri=${domainUri}/login`;
      ExceptionManager(exc, route, "Error Login with social media");
      return rejectWithValue("Error Login with social media");
    }
  }
);

export const checkUserRequest = createAsyncThunk("core/views/login/checkUser",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const { username } = payload;
      const data = await clientGraphQLAuthMutation(
        `
          mutation Mutation($username: String!) {
            checkUser(username: $username) {
              exists,
              multiAccount
            }
          }`,
        {
          username
        }
      );


      if (!data.checkUser?.exists) {
        throw "Username or email entered is incorrect.";
      }

      return data.checkUser

    } catch (exc) {
      // catch throw
      ExceptionManager(exc, "Core/views/login/redux", "checkMigrate");
      dispatch(loginResult({ cognitoValues: null, showConfirm: false, error: exc, checkUser: null }));
      return rejectWithValue(exc);
    }
  }
);

export const validateUser = createAsyncThunk("core/views/login/validateUser",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const { username, password } = payload;
      const data = await clientGraphQLAuthMutation(
        `
          mutation Mutation($username: String!, $password: String!) {
            validateUser(username: $username, password: $password) {
              cognitoVerified
              users {
                id
                username
                email
                companyId
                registrationStatus
                companyTitle
                isSubUser
                validateUser
              }
            }
          }`,
        {
          username,
          password
        }
      );

      if (data.error) {
        ExceptionManager(exc, "Core/views/login/redux", "validateUser");
        return rejectWithValue("Username or email entered is incorrect.");
      }

      if (!data.validateUser.cognitoVerified) {
        return rejectWithValue('login_user_pending')
      }

      return data.validateUser

    } catch (exc) {
      // catch throw
      ExceptionManager(exc, "Core/views/login/redux", "checkMigrate");
      dispatch(loginResult({ cognitoValues: null, showConfirm: false, error: exc }));
      return rejectWithValue(exc);
    }
  }
);

export const login = createAsyncThunk("core/views/login/login",
  async ({ username, password, authId, navigate }, { dispatch, rejectWithValue }) => {
    try {

      dispatch(logout());
      const data = await clientGraphQLAuthMutation(
        `
              mutation ($username: String!, $password: String!, $authId: String){
                    result: signIn(username:$username, password:$password, authId: $authId){
                        authenticationResult{
                            AccessToken
                            ExpiresIn
                            IdToken
                            RefreshToken
                            ChallengeName
                            Session
                            SessionId
                        },
                        emailVerified,
                        username
                    }
                }
          `,
        { username, password, authId }
      );

      if (data && data.result && data.result.authenticationResult) {
        const { emailVerified, authenticationResult, username } = data.result;
        if (!emailVerified) {
          rejectWithValue("login_user_pending")
        } else if (authenticationResult.ChallengeName === "NEW_PASSWORD_REQUIRED") {
          let values = {
            username,
            session: authenticationResult.Session
          };
          dispatch(newPasswordRequiredResult(values));
          navigate("/forceChangePassword");
        } else {
          localStorage.removeItem("sm");
          localStorage.setItem("AccessToken", authenticationResult.AccessToken);
          localStorage.setItem("RefreshToken", authenticationResult.RefreshToken);
          localStorage.setItem("IdToken", authenticationResult.IdToken);
          setCookie("GPSTSharedOAUTHToken", authenticationResult.IdToken, 1);
          localStorage.setItem("username", data.result.username);
          localStorage.setItem("SessionId", authenticationResult.SessionId);

          //remove local preferences
          localStorage.removeItem("preferencesUser");
          localStorage.removeItem("preferencesCompany");
          localStorage.removeItem("preferencesOther");

          dispatch(loginResult({ cognitoValues: authenticationResult, showConfirm: false }));
          navigate("/");
        }
      }
    } catch (exc) {
      // catch throw
      ExceptionManager(exc, route, "login");
      dispatch(loginResult({ cognitoValues: null, showConfirm: false, error: "exc" }));
      navigate("/login");
      return rejectWithValue(exc);
    }
  }
);

export const termsAndCondition = createAsyncThunk("core/views/login/termsAndCondition",
  async ({ username, password, authId, navigate }, { dispatch, rejectWithValue }) => {
    try {
      const data = await clientGraphQLAuthMutation(
        `
               mutation ($username: String!, $password: String!, $authId: String){
                    result: acceptedTermAndCondition(username:$username, password:$password, authId: $authId){
                        authenticationResult{
                            AccessToken
                            ExpiresIn
                            IdToken
                            RefreshToken
                            ChallengeName
                            Session
                        },
                        emailVerified,
                        username
                    }
                }
            `,
        { username, password, authId }
      );
      if (data && data.result && data.result.authenticationResult) {
        const { authenticationResult } = data.result;
        localStorage.removeItem("sm");
        localStorage.setItem("AccessToken", authenticationResult.AccessToken);
        localStorage.setItem("RefreshToken", authenticationResult.RefreshToken);
        localStorage.setItem("IdToken", authenticationResult.IdToken);
        setCookie("GPSTSharedOAUTHToken", authenticationResult.IdToken, 1);
        localStorage.setItem("username", data.result.username);

        //remove local preferences
        localStorage.removeItem("preferencesUser");
        localStorage.removeItem("preferencesCompany");
        localStorage.removeItem("preferencesOther");

        dispatch(loginResult({ cognitoValues: authenticationResult, showConfirm: false }));
        navigate("/");
      }
    } catch (exc) {
      // catch throw
      ExceptionManager(exc, route, "termsAndCondition");
      dispatch(loginResult({ cognitoValues: null, showConfirm: false, error: exc }));
      navigate("/login");
      return rejectWithValue(exc);
    }
  }
);

export const loginWithPM = createAsyncThunk("core/views/login/loginWithPM",
  async ({ token, navigate }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(logout());
      const data = await clientGraphQLAuthMutation(
        `
            mutation signInWithPM ($token: String!) {
                result: signInWithPM (token: $token) {
                    authenticationResult{
                        AccessToken
                        ExpiresIn
                        IdToken
                        RefreshToken
                    }
                    emailVerified
                    username
                }
            }
        `,
        { token }
      );
      if (data && data.result && data.result.authenticationResult) {
        const { authenticationResult, username } = data.result;

        localStorage.setItem("AccessToken", authenticationResult.AccessToken);
        localStorage.setItem("RefreshToken", authenticationResult.RefreshToken);
        localStorage.setItem("IdToken", authenticationResult.IdToken);
        setCookie("GPSTSharedOAUTHToken", authenticationResult.IdToken, 1);
        localStorage.setItem("username", username);
        localStorage.setItem("sm", true);
        //remove local preferences
        localStorage.removeItem("preferencesUser");
        localStorage.removeItem("preferencesCompany");
        localStorage.removeItem("preferencesOther");

        dispatch(loginResult({ cognitoValues: authenticationResult, showConfirm: false }));
        navigate("/app");
      }
    } catch (exc) {
      navigate("/login");
      // catch throw
      ExceptionManager(exc, route, "loginWithPM");
      dispatch(
        loginResult({
          cognitoValues: null,
          showConfirm: false,
          error: "Incorrect Username or Password"
        })
      );
      return rejectWithValue("Incorrect Username or Password");
    }
  }
);

export const loginConfirm = createAsyncThunk("core/views/login/loginConfirm",
  async ({ username, code, cognitoValues, navigate, messages }, { dispatch, rejectWithValue }) => {
    try {
      const data = await clientGraphQLAuthMutation(
        `
            mutation ($accessToken: String!, $code: String!, $sessionId: String) {
                result: verifyEmail(accessToken: $accessToken, code: $code, sessionId: $sessionId)
            }
          `,
        { accessToken: cognitoValues.AccessToken, code: code.toString(), sessionId: cognitoValues.SessionId }
      );
      if (data && data.result) {
        localStorage.removeItem("sm");
        localStorage.setItem("AccessToken", cognitoValues.AccessToken);
        localStorage.setItem("RefreshToken", cognitoValues.RefreshToken);
        localStorage.setItem("IdToken", cognitoValues.IdToken);
        setCookie("GPSTSharedOAUTHToken", cognitoValues.IdToken, 1);
        localStorage.setItem("username", username);
        //remove local preferences
        localStorage.removeItem("preferencesUser");
        localStorage.removeItem("preferencesCompany");
        localStorage.removeItem("preferencesOther");

        dispatch(loginConfirmResult());
        navigate("/");
      } else {
        dispatch(
          loginConfirmResult({
            error:
              data.errorMessage ||
              data?.errors[0]?.message ||
              messages["confirmUser_verifyCodeError"]
          })
        );
      }
      return {
        error:
          data.errorMessage || data?.errors[0]?.message || messages["confirmUser_verifyCodeError"]
      };
    } catch (exc) {
      // catch throw
      ExceptionManager(exc, route, "loginConfirm");
      dispatch(loginConfirmResult({ error: exc }));
      return rejectWithValue(exc);
    }
  }
);

export const getLoginPage = createAsyncThunk("core/views/login/getLoginPage",
  async ({ fileKey, preview = false, language, navigate }, { dispatch, rejectWithValue }) => {
    try {
      const query = `query getLoginPage ($fileKey: String!, $preview: Boolean!, $language: String!) {
            page: getLoginPage (fileKey: $fileKey, preview: $preview, language: $language)
        }`;
      const response = await clientQuery(
        query,
        {
          fileKey,
          preview,
          language
        },
        endpoints.COGNITO_URL,
        {
          "x-api-key": endpoints.COGNITO_API_KEY
        }
      );

      if (!response || !response?.page || response?.page === "<p></p>") {
        return rejectWithValue("");
      }
      dispatch(getLoginPageResult(response.page));
      navigate("/login", { replace: true });
      return response.page;
    } catch (exc) {
      // catch throw
      ExceptionManager(exc, route, "getLoginPage");
      return rejectWithValue(exc);
    }
  }
);

const loginRedux = createSlice({
  name: "core/views/login",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE
    },
    loginConfirmClose: () => {
      return { ...INIT_STATE };
    },
    loginResult: (state, action) => {
      state.loading = false;
      state.loadingSM = false;
      if (!action.payload) {
        state.cognitoValues = INIT_STATE.cognitoValues;
        state.showConfirm = INIT_STATE.showConfirm;
        state.error = INIT_STATE.error;
        state.token = INIT_STATE.token;
        state.isSocialMediaLogin = INIT_STATE.isSocialMediaLogin;
        return;
      }
      state.cognitoValues = action.payload.cognitoValues;
      state.showConfirm = action.payload.showConfirm;
      state.error = action.payload.error;
      state.token = action.payload.token;
      state.isSocialMediaLogin = action.payload.isSocialMediaLogin || false;
    },
    getLoginPageResult: (state, action) => {
      state.loginPage = String(action.payload);
    },
    loginSetError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    loginConfirmResult: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    newPasswordRequiredResult: (state, action) => {
      state.session = action.payload.session;
      state.username = action.payload.username;
    },
    updateTermsAndCondition: (state, action) => {
      state.termAndConditionData = action.payload;
    }
  },
  extraReducers: (builder) => {
    // builder.addCase(resetALL, () => INIT_STATE);

    // checkLoginUserByCode
    builder.addCase(checkLoginUserByCode.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(checkLoginUserByCode.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(checkLoginUserByCode.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // validateUser
    builder.addCase(validateUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(validateUser.fulfilled, (state, action) => {
      state.loading = false;
      state.verifiedUsers = action.payload;
    });
    builder.addCase(validateUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // login
    builder.addCase(login.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(login.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // termsAndCondition
    builder.addCase(termsAndCondition.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(termsAndCondition.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(termsAndCondition.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // loginWithPM
    builder.addCase(loginWithPM.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(loginWithPM.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(loginWithPM.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // loginConfirm
    builder.addCase(loginConfirm.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(loginConfirm.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(loginConfirm.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // getLoginPage
    builder.addCase(getLoginPage.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLoginPage.fulfilled, (state, action) => {
      state.loading = false;
      state.loginPage = action.payload;
    });
    builder.addCase(getLoginPage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.loginPage = null;
    });

    // getLoginPage
    builder.addCase(checkUserRequest.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.checkUser = null;
    });
    builder.addCase(checkUserRequest.fulfilled, (state, action) => {
      state.loading = false;
      state.checkUser = action.payload;
    });
    builder.addCase(checkUserRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.checkUser = null;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = loginRedux;

// Extract and export each action creator by name
export const {
  reset,
  loginConfirmClose,
  loginResult,
  loginConfirmResult,
  getLoginPageResult,
  checkMigrateResult,
  newPasswordRequiredResult,
  updateTermsAndCondition,
  loginSetError,
} = actions;

// Export the reducer, either as a default or named export
export default reducer;
